import React from 'react';

export const ErrorMessageComponent = ({ message }) => (
  <div
    style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'red', fontSize: '16px' }}
  >
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" stroke="red" strokeWidth="2" fill="none" />
      <line x1="12" y1="7" x2="12" y2="13" stroke="red" strokeWidth="2" />
      <circle cx="12" cy="17" r="1.5" fill="red" />
    </svg>
    <span>{message}</span>
  </div>
);
